import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Paper, Box, Divider } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { baseUrl } from "../../../../config/const";
import { AuthContext } from "../../../../AppContext";
import GajianTraineeTable from "./components/GajianTable";

const GajianTrainee = () => {
  const { state } = useContext(AuthContext);
  const history = useHistory();
  const [listToko, setListToko] = useState([]);

  const getListKasir = async () => {
    try {
      const {
        data: { data, msg },
      } = await axios.get(`${baseUrl}/getAllToko`);

      setListToko(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getListKasir();
  }, []);

  return (
    <Paper style={{ padding: 20 }}>
      <GajianTraineeTable listToko={listToko} />
      <Box style={{ height: 80 }} />
    </Paper>
  );
};

export default GajianTrainee;
